import type { RichTextFontSchemaType } from '@vedalib/editor/lib/brand'
import type { EditorElementError } from '@vedalib/editor/lib/elements'
import type { RichTextValue } from '@vedalib/rich-text'
import React from 'react'

import type { ElementFontCss } from 'services/Branding/types'

import RichTextCore from './RichTextCore'
import type { RichTextRef } from './RichTextTypes'
import { RichTextViewer } from './RichTextViewer'

export type IRichTextProps = {
  name: string
  waiting?: boolean
  value: RichTextValue
  active: boolean
  disabled?: boolean
  isPreview?: boolean
  isV2?: boolean
  styles: ElementFontCss<RichTextFontSchemaType>
  cursorPosition?: 'start' | 'end'
  autofocus?: boolean
  placeholder?: string
} & (
  | {
      onChange?: (value: RichTextValue | null, error?: EditorElementError[]) => void
      iterable: true
      onUp?: () => void
      onDown?: () => void
    }
  | {
      onChange?: (value: RichTextValue, error?: EditorElementError[]) => void
      iterable?: never
      onUp?: never
      onDown?: never
    }
)

const RichText = React.forwardRef<RichTextRef, IRichTextProps>(
  ({ value, isPreview, styles, isV2, ...rest }, ref) =>
    isPreview ? (
      <RichTextViewer isV2={isV2} styles={styles} value={value} />
    ) : (
      <RichTextCore {...rest} isV2={isV2} ref={ref} styles={styles} value={value} />
    ),
)

RichText.displayName = 'RichText'

export default React.memo(RichText)
